/**
 * Web stub for `@revopush/react-native-code-push`.
 * The package is native-only; on web its `AlertAdapter.js` destructures `Alert`
 * from react-native-web (where it doesn't exist) and crashes at import time.
 * Metro redirects the package to this stub on the web platform (see metro.config.js).
 *
 * The `@/libs/revopush` wrapper still runs on web, but every function short-circuits
 * through a `Platform.OS` guard before it would call any of these no-ops. Only
 * `SyncStatus` and `allowRestart` are read at module-eval time, so those must exist.
 */
'use strict';

const SyncStatus = {
  UP_TO_DATE: 0,
  UPDATE_INSTALLED: 1,
  UPDATE_IGNORED: 2,
  UNKNOWN_ERROR: 3,
  SYNC_IN_PROGRESS: 4,
  CHECKING_FOR_UPDATE: 5,
  AWAITING_USER_ACTION: 6,
  DOWNLOADING_PACKAGE: 7,
  INSTALLING_UPDATE: 8,
};

const InstallMode = {
  IMMEDIATE: 0,
  ON_NEXT_RESTART: 1,
  ON_NEXT_RESUME: 2,
  ON_NEXT_SUSPEND: 3,
};

const CheckFrequency = {
  ON_APP_START: 0,
  ON_APP_RESUME: 1,
  MANUAL: 2,
};

const noop = () => {};

const CodePush = {
  SyncStatus,
  InstallMode,
  CheckFrequency,
  allowRestart: noop,
  disallowRestart: noop,
  checkForUpdate: async () => null,
  sync: async () => SyncStatus.UP_TO_DATE,
  notifyAppReady: async () => {},
  notifyApplicationReady: async () => {},
  restartApp: noop,
  getUpdateMetadata: async () => null,
  getCurrentPackage: async () => null,
};

module.exports = CodePush;
module.exports.default = CodePush;
